import SignIn from 'shared/components/views/sign-in/SignIn';
import { AppSettingsProvider } from 'shared/contexts/AppSettingsContext';
import { CheckAuthentication } from 'shared/components/auth';
import { ThemeProvider } from 'shared/contexts/theme-provider';
import { TranslationProvider } from 'shared/contexts/translation-provider';

import { Route, Routes } from 'react-router-dom';
import { CertificateUpload } from 'public';
import { AlertProvider } from 'shared/components/alerts';
import { App } from './app';

const Root = () => {
  return (
    <AppSettingsProvider>
      <ThemeProvider>
        <TranslationProvider>
          <AlertProvider>
            <Routes>
              <Route path="/certificate-upload" element={<CertificateUpload />} />
              <Route
                path="*"
                element={
                  <CheckAuthentication>
                    {(signedIn) => (signedIn ? <App /> : <SignIn />)}
                  </CheckAuthentication>
                }
              />
            </Routes>
          </AlertProvider>
        </TranslationProvider>
      </ThemeProvider>
    </AppSettingsProvider>
  );
};

export { Root };
